module.exports = __webpack_public_path__ + "img/18.104.B.109e3be6.png";